import { useMemo } from "react";
import { useFilters } from "../../../../../utils/hooks/useFilters";

export const useFilterResourceParams = (name?: string) => {
    const [filters] = useFilters();

    return useMemo(() => {
        if (!name) return undefined;
        const filterValue = filters?.filters?.find((filter: any) => filter.name === name)?.value;
        const ids = (Array.isArray(filterValue) ? filterValue : filterValue ? [filterValue] : [])
            .map((item: any) => typeof item === "object" ? item.id : item)
            .filter(Boolean);
        if (!ids.length) return undefined;
        return {
            "filter[id][value]": ids,
            "filter[id][method]": "exact",
        };
    }, [filters, name]);
};
